var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 88,
    viewBox: "0 0 102 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.7 0.199985V15.5C96.9 16.3 93 18.3 90 21.5C87 24.7 84.7 28.7 83.1 33.5C81.7 38.3 81 43.5 81 49.1H99.6V87.5H61.5V52.4C61.5 40.6 63.4 31.2 67.2 24.2C71 17 75.9 11.5 81.9 7.7C88.1 3.9 94.7 1.39999 101.7 0.199985ZM41.1 0.199985V15.5C36.3 16.3 32.4 18.3 29.4 21.5C26.4 24.7 24.1 28.7 22.5 33.5C21.1 38.3 20.4 43.5 20.4 49.1H39V87.5H0.900002V52.4C0.900002 40.6 2.8 31.2 6.6 24.2C10.4 17 15.3 11.5 21.3 7.7C27.5 3.9 34.1 1.39999 41.1 0.199985Z",
    fill: "#1C1C1C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuotes);
export default __webpack_public_path__ + "static/media/quotes.3b45df02ee49233c0e15eae4d321a1c5.svg";
export { ForwardRef as ReactComponent };